















import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import AbpConst from "@/lib/appconst";
@Component
export default class ComponentNoteModal extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  @Prop({ type: String, default: "" }) syncNote: String;
  @Prop({ type: String, default: Util.L('Note') }) title: String;
  @Prop({ type: String, default: Util.L('Note') }) header: String;

  note:String="";
  save() {
      if(Util.isEmpty(this.note.toString()))
      {
          this.$Modal.error({
            title: this.L("ErrorTitle"),
            content: Util.L("Error.CancelReasonRequired"),
            okText: Util.getYesText(),
            onOk: async () => {
              (this.$refs.note as any).focus();
           }
        });
          return;
      }
        this.$emit('update:note', this.note)
        this.$emit("save-success");
        this.$emit("input", false);
  }
  cancel() {
    this.note = "";
    this.$emit('update:note', this.note);
    (this.$refs.formNote as any).resetFields();
    this.$emit("input", false);
  }
  async visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
      this.note = this.syncNote;
    }
  }
}
